'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.systemToReviews', [])

.factory('systemToReviewService', ['$http', '$q', function ($http, $q) {

    var service = {};

    var baseUrl = environment.apiUrl + '/ID/AccessReview/API';

    // HttpGet
    service.getStateAccessReview = function (executedBy) {
        return $http.get(baseUrl + '/GetStateAccessReview?executedBy=' + executedBy)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getNextSystemRoleToReview = function (executedBy) {
        return $http.get(baseUrl + '/GetNextSystemRoleToReview?executedBy=' + executedBy);
    }

    service.getActualSystemRolesToReview = function (systemRoleId, executedBy) {
        return $http.get(baseUrl + '/GetActualSystemRolesToReview/' + systemRoleId + '?executedBy=' + executedBy)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getNbRemainingSystemsToReview = function (executedBy) {
        return $http.get(baseUrl + '/GetNbRemainingSystemsToReview?executedBy=' + executedBy)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getSystemsAndSystemRolesToReview = function (executedBy) {
        return $http.get(baseUrl + '/GetSystemsAndSystemRolesToReview?executedBy=' + executedBy)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getToRemoveSystemRolesToReview = function (executedBy) {
        return $http.get(baseUrl + '/GetToRemoveSystemRolesToReview?executedBy=' + executedBy)
                    .then(function (response) {
                        return response.data;
                    });
    }

    // HttpPost
    service.confirmSystemReview = function (systemToReview, executedBy) {
        return $http.post(baseUrl + '/ConfirmSystemReview?executedBy=' + executedBy,
                          { reviewedSystem: systemToReview });
    }

    service.submitAccessReview = function (executedBy) {
        return $http.post(baseUrl + '/SubmitAccessReview?executedBy=' + executedBy)
                    .then(function (response) {
                        return response.data;
                    });
    }

    return service;
}]);
